<template>
  <el-container>
    <el-header class="animate__animated animate__fadeInDown">
      <h3 class="nesc_title40">{{ $route.params.type == 'highRateCell' ? $t('lang.highRateCell') : $t('lang.batteryModule') }}</h3>
    </el-header>
    <el-main>
      <div class="nesc_cont1360 nesc_about_content clearfix">
        <el-row type="flex" class="row-bg" justify="center">
          <el-col v-if="$route.params.type == 'highRateCell'" class="flex-row-center" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <img :src="cellImg" style="width: 100%;max-width: 924px;">
          </el-col>
          <el-col v-if="$route.params.type == 'batteryModule'" style="position:relative;" class="flex-row-center" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <img :src="module2" style="width: 100%;max-width: 254px;margin-top: -90px">
            <img :src="module1" style="width: 100%;max-width: 254px;margin-top: 120px;margin-right: 30px;margin-left: 30px">
            <img :src="module3" style="width: 100%;max-width: 354px;margin-top: -20px">
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg margin-bottom" justify="space-around" style="flex-wrap: wrap">
          <el-col v-for="(item, index) in renderData" :key="index" class="flex-row-center margin-top " :xs="8" :sm="8" :md="4" :lg="4" :xl="4">
            <div class="cellMsgContainer">
              <p style="padding: 0 18px">{{ $t('lang.' + item.title) }}</p>
              <p style="padding: 10px 18px;color: #000;font-weight: bold">{{ item.val }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>

import cellImg from '../assets/image/cell/cell.png'
import module1 from '../assets/image/batteryModule/module1.png'
import module2 from '../assets/image/batteryModule/module2.png'
import module3 from '../assets/image/batteryModule/module3.png'

export default {
  name: 'Productions',
  data: () => {
    return {
      cellImg,
      module1,
      module2,
      module3,
      renderData: []
    }
  },

  watch: {
    $route: {
      handler: function(route) {
        console.log(route.params.type)
        if (route.params.type === 'batteryModule') {
          this.renderData = [
            { title: 'platformDevelop', val: this.$t('lang.moduleFreeSet') }, { title: 'highRate', val: '3C(20C Max)' }, { title: 'highHengLiu', val: '>93%' },
            { title: 'highLoopLife', val: '>1500次(3C)' }, { title: 'highTempRange', val: '-22~+55°C' }, { title: 'highPower', val: '>150Wh/kg' }
          ]
        } else if (route.params.type === 'highRateCell') {
          this.renderData = [
            { title: 'loopLife', val: '3000次' }, { title: 'energyDensity', val: '160-240wh/kg' }, { title: 'workTemp', val: '-40~+65°C' },
            { title: 'standardVol', val: '3.7V' }, { title: 'chargeRate', val: '5C(10 Max)' }, { title: 'dischargeRate', val: '10C(20C Max)' }
          ]
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
}
.el-main {
  margin-bottom: 100px;
}

.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin: 0 auto;
}

.cellMsgContainer {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background: url("../assets/image/menuselect.png") center / cover no-repeat;
  p {
    color: #666666;
    font-family: "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
    font-size: 14px;
    text-align: center;
  }
  p:last-of-type {
    padding-top: 10px;
  }
}

@media screen and (max-width: 991px) {
  .cellMsgContainer {
    width: 120px;
    height: 120px;
    p {
      font-size: 12px;
    }
  }
}

</style>
